import { FormInput } from "@actinc/dls/components";
import { Controller } from "react-hook-form";

import { provideDefaultMessages } from "../../services/formUtils";

const ControlledFormInput = ({
  control,
  defaultValue,
  disabled,
  endAdornment,
  formControlProps,
  fullWidth,
  id,
  inputProps,
  label,
  multiline,
  name,
  onBlur: handleBlur,
  onChange: handleChange,
  readonly,
  rules = {},
  startAdornment,
  trigger,
  ...props
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({
        field: { onBlur, onChange, ref, value },
        fieldState: { error },
      }) => (
        <FormInput
          disabled={disabled}
          error={Boolean(error)}
          errorMessage={error?.message}
          formControlProps={{
            size: "small",
            sx: {
              marginBottom: 2,
              minWidth: () => {
                if (fullWidth) return `0px`;
                if (rules.maxLength > 50) return `${rules.maxLength * 0.4}em`;
                return `200px`;
              },
              "& .MuiInputBase-root": {
                marginTop: 0,
              },
            },
            ...formControlProps,
          }}
          endAdornment={endAdornment}
          startAdornment={startAdornment}
          fullWidth={!rules.maxLength || fullWidth}
          id={id}
          inputProps={{
            ...inputProps,
            readOnly: !!readonly,
          }}
          inputRef={ref}
          label={label}
          multiline={
            multiline !== undefined ? multiline : !rules.maxLength && !fullWidth
          }
          name={name}
          onBlur={(e) => {
            handleBlur && handleBlur(e);
            onBlur(e);
            trigger && trigger();
          }}
          onChange={(e) => {
            handleChange && handleChange(e);
            onChange(e);
            trigger && trigger();
          }}
          required={!!rules.required}
          value={typeof value === "undefined" || value === null ? "" : value}
          {...props}
        />
      )}
      rules={provideDefaultMessages(rules)}
    />
  );
};

export { ControlledFormInput };
